import { TAccordionCellRenderer } from '../../../../components/common/generic/responsiveTable/renderers/AccordionCell';
import AccordionHTMLCellRenderer from '../../../../components/common/generic/responsiveTable/renderers/AccordionHTMLCellRenderer';
import { TResponsiveTableCellRenderer } from '../../../../components/common/generic/responsiveTable/types';

export type TRenderersDefinition = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  accordionRenderer?: TAccordionCellRenderer<any>;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  renderer?: TResponsiveTableCellRenderer<any>;
};

export type TColumnsRenderers = Record<
  string,
  Record<string, TRenderersDefinition>
>;

const columnsRenderers: TColumnsRenderers = {
  tasklist: {
    colProSta: {
      /**
       * Está usando el htmlRenderer como ejemplo, pero hay que hacer uno
       * propio para este componente y sustituirlo
       */
      accordionRenderer: AccordionHTMLCellRenderer,
    },
    colTskSta: {
      /**
       * Está usando el htmlRenderer como ejemplo, pero hay que hacer uno
       * propio para este componente y sustituirlo
       */
      accordionRenderer: AccordionHTMLCellRenderer,
    },
  },
};

export default columnsRenderers;
